import { render, staticRenderFns } from "./Origin-Detail.vue?vue&type=template&id=383e6c4c&scoped=true"
import script from "./Origin-Detail.vue?vue&type=script&lang=js"
export * from "./Origin-Detail.vue?vue&type=script&lang=js"
import style0 from "./Origin-Detail.vue?vue&type=style&index=0&id=383e6c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e6c4c",
  null
  
)

export default component.exports